import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import Auth from '../auth/Auth'
import '../css/styles.css'
import { Grid, Row, Col } from 'react-flexbox-grid'

import Paper from '@material-ui/core/Paper'
import { injectIntl, intlShape } from 'react-intl'
import { localize, localizeImg } from '../util/Localizer'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { resetMessage } from '../redux/actions/logoutActions'
import { login, validateSession, saveUserData } from '../redux/actions/loginActions'
import { toggleLanguage } from '../redux/actions/languageActions'
import { fetchAppContent } from '../redux/actions/appContentActions'
import Config from '../Config'
import Loading from '../widgets/Loading'
import { getSessionIdFromSearchString } from '../util/UrlSearchParams'

// Our Components
import PasswordField from '../controls/PasswordField'
import TopNav from '../widgets/common/TopNav'
import InputField from '../controls/InputField'
import ErrorMessage from '../widgets/common/ErrorMessage'
import RBButton from '../controls/RBButton'

import { withStyles } from '@material-ui/core/styles'
import { Dimensions } from '../theme'
import Cookies from 'js-cookie'

class Login extends React.Component {
  constructor () {
    super()
    this.login = this.login.bind(this)
    this.renderForm = this.renderForm.bind(this)
    this.renderLoading = this.renderLoading.bind(this)
    this.forgotPassword = this.forgotPassword.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validate = this.validate.bind(this)
    this.state = {
      userName: null,
      password: null,
      isSessionValidation: false,
      noUserName: '',
      noPassword: ''
    }
  }

  componentDidMount () {
    const search = this.props.location.search
    if (Config.useSSO) {
      // if there is single sign on, check for a session id
      // if the session id is ok, push to claims
      // if not, show login form
      const sessionId = getSessionIdFromSearchString(search)
      if (sessionId) {
        Cookies.set('mws', sessionId, { expires: 7 })
        this.props.saveUserData(this.state.userName, this.state.password, true)
        this.props.validateSession(sessionId)
      } else {
        if (Auth.isAuthenticated) {
          return <Redirect to={`/${Config.landingPage}`} />
        } else {
          window.location.href = Config.loginFallBack
        }
      }
    }
    if (this.props.appContent && !this.props.appContent.content.length > 0) {
      this.props.fetchAppContent()
    }
  }

  login (event) {
    event.preventDefault()
    const { userName, password } = this.state
    if (this.validate()) {
      if ((userName && userName.trim().length === 0) || (password && password.trim().length === 0)) {
        this.props.resetMessage()
      } else {
        this.props.saveUserData(userName, password, false)
        this.props.resetMessage()
        window.localStorage.setItem('username', this.userName.input.value)
        this.props.login(this.userName.input.value, this.password.input.value)
      }
    }
  }

  forgotPassword (e) {
    e.preventDefault()
    this.props.push('/ForgotPassword')
  }

  handleInputChange (event) {
    const state = this.state
    const targetId = event.target.id
    state[targetId] = event.target.value.trim()
    this.setState({ state })
  }

  validate () {
    let valid = true
    const state = this.state
    if ((state.userName === null) || (state.userName === '')) {
      valid = false
      this.setState({ noUserName: localize('error.account.login.noUsername') })
    } else {
      valid = true
      this.setState({ noUserName: '' })
    }

    if ((state.password === null) || (state.password === '')) {
      valid = false
      this.setState({ noPassword: localize('error.account.login.noPassword') })
    } else {
      valid = true
      this.setState({ noPassword: '' })
    }
    return valid
  }

  renderLoading () {
    return (
      <div>
        <Loading message={localize('common.loadingContent')} />
      </div>
    )
  }

  renderForm () {
    const values = this.state
    return (Config.useSSO ? this.renderLoading() : (
      <form action='/' id='login-form' className='clearfix' style={{ marginTop: 50 }} autoComplete='off' onSubmit={(e) => this.login(e)}>
        <ErrorMessage error={this.props.error || this.props.msg} />
        <InputField
          floatingLabelText={localize('pages.login.username')}
          fullWidth
          className='userName'
          type='text'
          id='userName'
          autoComplete='off'
          ref={(input) => { this.userName = input }}
          errorText={values.noUserName ? values.noUserName : ''}
          onChange={this.handleInputChange}
          onBlur={this.validate} /><br />
        <PasswordField
          floatingLabelText={localize('pages.login.password')}
          fullWidth
          className='password'
          type='password'
          id='password'
          autoComplete='off'
          ref={(input) => { this.password = input }}
          errorText={values.noPassword ? values.noPassword : ''}
          onChange={this.handleInputChange}
          onBlur={this.validate} />
        <br />
        <div className='centered'>
          <RBButton
            type='submit'
            id='btnLogin'
            label={localize('pages.login.login')}
            variant='contained'
            styles={{ width: '100%', height: 42 }}
            fullWidth
            primary
            loading={this.props.pageLoading}
          />
        </div>
        {Config.useSSO ? null
          : <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 10 }}>
            <RBButton id='forgotPass' onClick={this.forgotPassword} label={localize('pages.login.forgotPassword')} styles={{ alignSelf: 'right' }} color />
          </div>}
      </form>
    ))
  }

  render () {
    const { classes = {} } = this.props
    const logo = localizeImg('/img/logo.svg')

    // this will be re-added when nexgen and iuoe are ready.
    if (Config.loginFallBack && Config.useSSO && !this.props.valLoading && (this.props.valerror === true)) {
      window.location.href = Config.loginFallBack
      return this.renderLoading()
    }

    if (Auth.isAuthenticated) {
      const { ngrxMultiPolicies } = Auth.claims
      if (ngrxMultiPolicies) {
        // if the user has multiple policies redirect them there
        return <Redirect to={'MultiPolicy'} />
      } else {
        // if we are authenticated push to claims
        return <Redirect to={`/${Config.landingPage}`} />
      }
    }
    return (
      <div className={classes.loginPage}>
        <Grid fluid>
          <Row end='xs'>
            <Col>
              <TopNav primary />
            </Col>
          </Row>
          <Row center='lg' className={classes.screenHeight}>
            <Col xs={12} md={3} lg={3} />
            <Col xs={12} md={6} lg={6} id='login'>
              <Paper elevation={2} className={classes.loginCard}>
                <img src={logo} alt={localize('pages.login.logoAlt')} />
                {(Config.useSSO && this.props.valLoading)
                  ? this.renderLoading()
                  : this.renderForm()}
              </Paper>
            </Col>
            <Col xs={12} md={3} lg={3} />
          </Row>
        </Grid>
      </div>

    )
  }
}

Login.contextTypes = {
  intl: intlShape.isRequired,
  router: PropTypes.object
}

function mapStateToProps (state) {
  return {
    user: state.user,
    pageLoading: state.LoginReducers.pageLoading,
    error: state.LoginReducers.error,
    msg: state.LogoutReducers.msg,
    appContent: state.AppContentReducer.appContent || {},
    valLoading: state.LoginReducers.valLoading,
    valerror: state.LoginReducers.valerror,
    userEmail: state.LoginReducers.userEmail,
    userPassword: state.LoginReducers.userPassword,
    isSessionValidation: state.LoginReducers.isSessionValidation
  }
}

const ConnectedLogin = connect(mapStateToProps, {
  login,
  toggleLanguage,
  resetMessage,
  push,
  validateSession,
  fetchAppContent,
  saveUserData
})(injectIntl(Login))

const styles = {
  loginPage: {
    overflowY: 'scroll',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  loginCard: {
    width: '100%',
    maxWidth: '850px',
    padding: '45px 100px',
    textAlign: 'center',
    display: 'inline-block',
    '& img': {
      maxWidth: Dimensions.loginLogoMaxWidth
    },
    ['@media all and (max-width:525px)']: { // eslint-disable-line no-useless-computed-key
      padding: '45px 60px'
    },
    ['@media all and (max-width:375px)']: { // eslint-disable-line no-useless-computed-key
      padding: '45px 30px'
    }
  },
  screenHeight: {
    minHeight: 'calc(100vh)'
  }
}

export default withStyles(styles)(ConnectedLogin)



// WEBPACK FOOTER //
// ./src/components/Login.js